export const environment = {

    apiBaseUrl: 'https://mv-backoffice.staging.tourismotion.com/api/v1',

};
